export const STUDIO_ELEMENTS_TARGETS = {
  studioAddElement: `[data-test-id="add-button"]`,
  studioAddDrawer: `[data-test-id="add-drawer"]`,
  addTextBlock: `[data-plasmic-add-item-name="Text"]`,
  editorTabs: `.nav-tabs.hilite-tabs`,
  topBarPublishBtn: "#topbar-publish-btn",
  canvasFrameContainer: ".CanvasFrame__Container",
  canvasLeftPane: ".canvas-editor__left-pane-container",
  leftTabStrip: "#left-tab-strip",
  tplTreeRoot: ".tpltree__root",
  outlineTabKey: `[data-test-tabkey="outline"]`,
};

export const TOPFRAME_ELEMENTS_TARGETS = {
  publishFlowDialogRoot: "#publish-flow-dialog-root",
  publishFlowDialogVersionSection: "#publish-flow-dialog-root > :first-child",
  publishFlowDialogPublishBtn: "#publish-flow-dialog-publish-btn",
  publishFlowDialogAddWebsitePanel: "#publish-flow-dialog-add-website-panel",
  publishFlowDialogAddWebsiteBtn: "#publish-flow-dialog-add-website-btn",
  plasmicHostingSubsection: "#plasmic-hosting-subsection",
};
